// Video event — fires exactly once per video per page; tracks the initial play only (no resume/pause)

import { pushAdobeEvent } from './core';
import { getCurrentPagePayload } from './pageLoad';

export type VideoParams = {
  videoName: string;
};

type VideoPayload = {
  videoName: string;
};

// Tracks which video names have already fired to enforce the play-once rule
const _playedVideos = new Set<string>();

// Clears the played-video registry — useful for testing or after a page navigation
export const resetVideoTracking = (): void => {
  _playedVideos.clear();
};

// Pushes a 'Video Play' event the first time a given video is played; subsequent calls are no-ops
export const trackAdobeVideoPlay = (params: VideoParams): void => {
  if (_playedVideos.has(params.videoName)) return;

  _playedVideos.add(params.videoName);

  const page = getCurrentPagePayload();

  const eventName = 'Video Play';

  const video: VideoPayload = {
    videoName: params.videoName,
  };

  pushAdobeEvent({
    event: 'Video Play',
    eventName,
    eventDesc: `${eventName} - ${params.videoName}`,
    ...(page && { page }),
    video,
  });
};
